import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import PageHeader from '../../shared/PageHeader'
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined'
import ClaimsProcessingTable from './ClaimsProcessingTable'
import { Button, Drawer } from '@mui/material'
import ClaimsProcessingFilters from './ClaimsProcessingFilters'

function ClaimsProcessing () {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  const [filters, setFilters] = useState({
    vatInvoice: '',
    mobile: '',
    policyNumber: '',
    membership: '',
    episodeNumber: '',
    episodeType: '',
    date: ''
  })

  const handleChange = e => {
    const { name, value } = e.target
    setFilters(prev => ({ ...prev, [name]: value }))
  }

  const handleApplyFilters = () => {
    console.log('Applied filters:', filters)
    setOpen(false)
  }

  const toggleDrawer = open => () => setOpen(open)

  return (
    <div className='pre_auth_container !p-0 flex flex-col h-full'>
      <PageHeader title={t('Claims Processing')}>
        <Button
          variant='outlined'
          size='small'
          onClick={() => setOpen(() => !open)}
          className='!border-primary !text-primary hover:!bg-primary/10'
          startIcon={<FilterAltOutlinedIcon />}
        >
          {t('Apply Filter')}
        </Button>
      </PageHeader>

      <div className='flex flex-1 overflow-hidden'>
        <Drawer open={open} anchor='right' onClose={toggleDrawer(false)}>
          <div className='p-4 bg-white border-r border-gray-200 overflow-y-auto !w-[300px]'>
            <h3 className='font-medium text-lg mb-4'>{t('Filters')}</h3>
            <ClaimsProcessingFilters
              filters={filters}
              onChange={handleChange}
              onApply={handleApplyFilters}
            />
          </div>
        </Drawer>
        <div className='flex-1 overflow-auto'>
          <ClaimsProcessingTable />
        </div>
      </div>
    </div>
  )
}

export default ClaimsProcessing
